export default __webpack_public_path__ + "static/media/NewIndiaAssurance.21b95307.svg";